import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { Link } from "@circleco/compass/components/Link";

import { t } from "@/i18n-js/instance";

export const PoweredByCircle = () => {
  const { currentCommunity } = usePunditUserContext();
  const communitySlug = currentCommunity?.slug ?? "";
  const url = `https://circle.so/?utm_source=powered-by&community=${communitySlug}`;

  return (
    <div className="flex items-center justify-center px-4 opacity-60">
      <Link
        color="secondary"
        href={url}
        rel="noopener noreferrer"
        target="_blank"
        typography="label-xs"
        variant="custom"
      >
        {t("powered_by_circle")}
      </Link>
    </div>
  );
};
